/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {useEffect} from 'react';
import debounce from 'lodash.debounce';

/**
 * Provides a utility hook to execute a callback function on screen resize.
 *
 * ```typescript
 * import {useScreenResize} from '@ion/dls/src/hooks/';
 * function calculateHeight(){
 *  return window.height - 24;
 * }
 *
 * useScreenResize(calculateHeight);
 *
 * ```
 */
export function useScreenResize(
  callback?: Function,
  params?: any,
  delay = 300
) {
  useEffect(() => {
    if (callback) {
      const handler = () => params ? callback(params) : callback();
      const listener = debounce(handler, delay);
      window.addEventListener('resize', listener);
      return () => window.removeEventListener('resize', listener);
    }
  }, [callback, params]);
}

export default useScreenResize;
